import { getToken } from "../authorization/auth";
import { API_ENDPOINT } from "../authorization/const";

export async function makeQuotation(data) {
    data["auth"] = getToken();
    const res = await fetch(API_ENDPOINT + "quotation/make", {
        method: "POST",
        body: JSON.stringify(data)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function getCompanyQuotationList(company) {
    const res = await fetch(API_ENDPOINT + "quotation/get/client/" + getToken() + "?client=" + company, { method: "GET" });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function getQuotation(quote) {
    const res = await fetch(API_ENDPOINT + "quotation/get/scheme/" + getToken() + "?scheme=" + quote, { method: "GET" });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}
export async function acceptQuotation(data) {
    data["auth"] = getToken();
    const res = await fetch(API_ENDPOINT + "quotation/accept/" + getToken(), {
        method: "POST",
        body: JSON.stringify(data)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}
